  
import * as Yup from 'yup';
import { NAME_REGEX } from '../../../../utils/common';

export const validationSchema = Yup.object().shape({
    sections: Yup.array().of(
        Yup.object().shape({
          name: Yup.string()
            .min(2, "Section name must be at least 2 characters")
            .max(50, "Section name must be at most 50 characters")
            .matches(NAME_REGEX, "Enter a valid Section name")
            .required("Section name is required"),
          description: Yup.string().matches(NAME_REGEX, "Enter a valid description")
            .required('Description is required'),
          fields: Yup.array().of(
            Yup.object().shape({
              label: Yup.string()
                .min(2, "Field name must be at least 2 characters")
                .max(50, "Field name must be at most 50 characters")
                .matches(NAME_REGEX, "Enter a valid Field name")
                .required("Field name is required."),
              placeholder: Yup.string().matches(NAME_REGEX, "Enter a valid Placeholder")
                .required('Placeholder is required.'),
                  property: Yup.object().shape({
                    note: Yup.object().shape({
                      message_note: Yup.string()
                        .max(100, "Message note must not exceed 100 characters.")
                        .nullable(""),
                    }),
                  }),
                }),
            )
        })
    )
});

export const validationRadio = Yup.object().shape({
  options: Yup.array().of(
    Yup.object().shape({
      label: Yup.string().required("Label is required"),
      value: Yup.string().required("Value is required"),
    })
  )
});
export const ValidationCalculation = Yup.object().shape({
  input_calculation_variables: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Variable name is required"),

        linked_field_uuid: Yup.string()
          .required("Linked Field is required"),

        default_val: Yup.string().nullable(),
      })
    )
});

export const ValidationSchmaForm = Yup.object().shape({
  validation_type_id: Yup.string()
    .required("Validation type is required"),

  regex_pattern: Yup.string()
    .required("Regex pattern is required"),

  message: Yup.string()
    .required("Error message is required"),
});

export const ValidationConditionSchema = Yup.object().shape({
  conditions: Yup.array()
    .of(
      Yup.object().shape({
        option_uuid: Yup.string().required("Option Value is required"),
        section: Yup.string().required("Section is required"),
        target_input_field_uuid: Yup.string().required("Input field is required"),
      })
    )
    .min(1, "At least one condition is required"),
});
